import { filtersTypeByIdMap } from "../../../../Components/Filters/filtersTypeById"

const { channel: _channel, ...receiptFilters } = filtersTypeByIdMap.receipt

export const CASE_FILTERS_TYPE_MAP = {
  ...receiptFilters,
  outcome: {
    id: "outcome",
    label: "Outcome",
    allBtnText: "All Outcomes",
    type: "checkbox"
  }
}
